<div
  class="flex flex-col w-full min-w-0 sm:absolute sm:inset-0 sm:overflow-hidden">
  <mat-drawer-container class="flex-auto sm:h-full">
    <!-- Drawer -->
    <mat-drawer
      class="sm:w-96 dark:bg-gray-900"
      [autoFocus]="false"
      [mode]="drawerMode"
      [opened]="drawerOpened"
      #drawer>
      <!-- Header -->
      <div class="flex items-center justify-between m-8 mr-6 sm:my-10">
        <!-- Title -->
        <div
          class="text-xl w-full h-5 font-semibold tracking-tight leading-none">
          <span *ngIf="!isTemplate"> Board settings </span>
          <span *ngIf="isTemplate"> Template settings </span>
        </div>
        <!-- Close button -->
        <div class="lg:hidden">
          <button mat-icon-button (click)="drawer.close()">
            <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
          </button>
        </div>
      </div>
      <!-- Panel links -->
      <div class="flex flex-col divide-y border-t border-b">
        <ng-container
          *ngFor="
            let panel of isTemplate ? templatePanels : boardPanels;
            trackBy: trackByFn
          ">
          <div
            class="flex px-8 py-5 cursor-pointer"
            [ngClass]="{
              'hover:bg-gray-100 dark:hover:bg-hover':
                !selectedPanel || selectedPanel !== panel.id,
              'bg-primary-50 dark:bg-hover':
                selectedPanel && selectedPanel === panel.id
            }"
            (click)="goToPanel(panel.id)">
            <mat-icon
              [ngClass]="{
                'text-hint': !selectedPanel || selectedPanel !== panel.id,
                'text-primary dark:text-primary-500':
                  selectedPanel && selectedPanel === panel.id
              }"
              [svgIcon]="panel.icon"></mat-icon>
            <div class="ml-3">
              <div
                class="font-medium leading-6"
                [ngClass]="{
                  'text-primary dark:text-primary-500':
                    selectedPanel && selectedPanel === panel.id
                }">
                {{ panel.title }}
              </div>
              <div class="mt-0.5 text-secondary">
                {{ panel.description }}
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </mat-drawer>

    <!-- Drawer content -->
    <mat-drawer-content class="flex flex-col">
      <!-- Main -->
      <div class="flex-auto px-1">
        <!-- Panel header -->
        <div class="flex items-center justify-between">
          <!-- Drawer toggle -->
          <button class="lg:hidden" mat-icon-button (click)="drawer.toggle()">
            <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
          </button>
          <!-- Close button -->
          <button
            class="ml-auto"
            mat-icon-button
            (click)="this._matDialogRef.close()">
            <mat-icon
              class="font-bold icon-size-5 m-2"
              aria-label="Close panel">
              close
            </mat-icon>
          </button>
        </div>

        <!-- Load settings panel -->
        <div class="mt-4 px-8">
          <ng-container [ngSwitch]="selectedPanel">
            <!-- Object details -->
            <ng-container *ngSwitchCase="'object-details'">
              <boardObject-details [role]="role"></boardObject-details>
            </ng-container>
            <!-- Access & Invites -->
            <ng-container *ngSwitchCase="'access-invites'">
              <settings-team-board [role]="role"></settings-team-board>
            </ng-container>
            <!-- Notifications -->
            <ng-container *ngSwitchCase="'choose-notifications'">
              <choose-notifications></choose-notifications>
            </ng-container>
            <!-- Custom Fields -->
            <ng-container *ngSwitchCase="'customize-cards-fields'">
              <app-customize-cards-fields></app-customize-cards-fields>
            </ng-container>
            <!-- Templates additional Panels -->
            <!-- Availability -->
            <ng-container *ngSwitchCase="'availability'">
              <template-availability></template-availability>
            </ng-container>
            <!-- Access & invites -->
            <ng-container *ngSwitchCase="'access-template'">
              <template-team></template-team>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
